function initOpenHoursComponent(app) {
    app.component('preview-open-hours', {
        template: '#preview-open-hours',
        props: {
            date: String,
            startTime: String,
            endTime: String,
        },
    });
}

export default initOpenHoursComponent;
